/* eslint-disable no-dupe-keys */
export default {
  coupon_definition: {
    name: '优惠券模板',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '券名',
      coupon_type: '券类型',
      discount_content_type: '抵扣内容',
      max_available_amount: '最大抵扣金额',
      coupon_value: '优惠金额/折扣',
      effective_date_type: '生效日期类型',
      effective_days: '生效天数',
      effective_begin_time: '生效开始日期',
      effective_end_time: '生效结束日期',
      order_amount_type: '约束类型',
      order_amount_greater_than: '适用订单',
      charge_stations: '适用电站',
      ev_charging_station: '适用电站',
      discount_stacking_type: '优惠叠加类型',
      given_coupons_count: '发放的数量',
      used_coupons_count: '已使用的数量',
      description: '规则说明',
      service_provider: '运营商',
      status: '状态',
      created_at: '创建时间',
      updated_at: '更新时间',
      no_limit: '无限制',
      after_given_label: '领券起{0}天内'
    },
    // Enum的属性
    coupon_types: {
      cash: '现金券',
      discount: '折扣券'
    },
    discount_content_types: {
      total_fee_discount: '订单总额抵扣',
      service_fee_discount: '服务费抵扣'
    },
    order_amount_type: {
      service_amount_required: '服务费',
      total_amount_required: '订单总额'
    },
    effective_date_types: {
      fixed: '指定日期',
      after_given: '从获取后开始'
    },
    discount_stacking_types: {
      exclusive: '优惠互斥',
      unrestricted: '优惠叠加'
    },
    statuses: {
      pending: '待生效',
      available: '生效中',
      expired: '已过期',
      disabled: '已停用',
      enabled: '可用的'
    },
    virtual_statuses: {
      pending: '待生效',
      available: '生效中',
      expired: '已过期'
    },
    real_statuses: {
      enabled: '启用的',
      disabled: '停用的'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询券名'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      coupons: '优惠券'
    },
    // 标题
    titles: {
      base_info: '基本信息',
      rule_info: '使用规则',
      activity_info: '活动信息'
    },
    list_tabs: {
      all: '全部',
      enabled: '开放的'
    },
    labels: {
      given_coupons_count: '已发放数',
      used_count: '已使用数'
    },
    tips: {
      max_available_amount: '最大可抵扣{0}元'
    },
    group_titles: {
      base: '基础信息',
      effective_time: '生效时间',
      rule_info: '使用规则'
    }
  }
}
